module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/filter-b5479a60fc996084fe7f598dbf16fee0.svg&quot;;"